import { apiClient } from './api';

// EG-52 — Platform Admin xem cửa hàng cross-tenant.
// BE endpoint: GET /stores, GET /stores/:id (read-only).

export interface StoreFilters {
  page?: number;
  limit?: number;
  tenant_id?: string;
  q?: string;
  state?: number;
  store_type?: number;
}

export interface Store {
  store_id: string;
  tenant_id?: string;
  code: string;
  name: string;
  address?: string;
  full_address?: string;
  hotline?: string;
  email?: string;
  state: number;
  store_type: number;
  working_hours?: string;
  working_days?: string;
  created_at: string;
  updated_at?: string;
}

export interface StoresResponse {
  data: Store[];
  meta: { page: number; limit: number; total: number; totalPages: number };
}

interface Envelope<T> {
  success: boolean;
  data: T;
}

interface StoreApiRaw {
  store_id?: string;
  _id?: string;
  tenant_id?: string;
  code?: string;
  name?: string;
  address?: string;
  full_address?: string;
  hotline?: string;
  email?: string;
  state?: number;
  store_type?: number;
  working_hours?: string;
  working_days?: string;
  created_at?: string;
  updated_at?: string;
}

const toStore = (raw: StoreApiRaw): Store => ({
  store_id: raw.store_id || raw._id || '',
  tenant_id: raw.tenant_id,
  code: raw.code || '',
  name: raw.name || '',
  address: raw.address,
  full_address: raw.full_address,
  hotline: raw.hotline,
  email: raw.email,
  state: raw.state ?? 0,
  store_type: raw.store_type ?? 1,
  working_hours: raw.working_hours,
  working_days: raw.working_days,
  created_at: raw.created_at || '',
  updated_at: raw.updated_at,
});

export const storeService = {
  getStores: async (filters: StoreFilters = {}): Promise<StoresResponse> => {
    const response = await apiClient.get<Envelope<{ items: StoreApiRaw[]; meta: StoresResponse['meta'] }>>(
      '/stores',
      { params: filters },
    );
    const payload = response.data?.data;
    return {
      data: (payload?.items || []).map(toStore),
      meta: payload?.meta || {
        page: filters.page || 1,
        limit: filters.limit || 20,
        total: 0,
        totalPages: 0,
      },
    };
  },

  getStoreById: async (id: string): Promise<Store> => {
    const response = await apiClient.get<Envelope<StoreApiRaw>>(`/stores/${id}`);
    return toStore(response.data.data);
  },
};

export default storeService;
